import React from 'react';
import { Helmet } from "react-helmet";
import Layout from '../../components/Layout';
import AudiForm from '../../components/AudiForm';
import Disclaimer from '../../components/Disclaimer';
// import ReturnToButton from '../../components/ReturnToButton';
import queryString from 'query-string';
import _find from 'lodash/find';
import { formatMobile, formatDate } from '../../functions/textFormatting';
import { prefCentreService } from '../../functions/apiRequestHelper';
import { gtmPageview } from '../../functions/gtm';
import DealerByPostcodeModule from '../../components/DealerByPostcodeModule';
import ModelModule from '../../components/ModelModule';
// import DescriptionModule from './DescriptionModule';
import DateTimeModule from './DateTimeModule';
import Loader from '../../components/Loader';
import MaintenanceMessage from '../../components/MaintenanceMessage';
import IconSelect from '../../audi-ui-components/icons/Select';
import {
    UI_AUDI,
    PATH_REQUEST_TESTDRIVE,
    PATH_THANKS,
    FIELD_TEXT,
    FIELD_CHECKBOX,
    FIELD_CHECKBOX_GROUP,
    LABEL_OPTIN,
    PREF_CONTACT_OPTIONS,
    MAINTENANCE_SF
} from '../../constants';
import './ratd.scss';

class RequestTestDrive extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            isFetchingUser: true,
            submitted: false,
            submittedData: {},
            submittedDealer: {},
            submittedVariant: {}
        }
    }

    componentDidMount() {
        this.isIframed = typeof window !== "undefined" && window.self !== window.top;
        const query = queryString.parse(this.props.location.search);
        if (query.sfid) {
            prefCentreService.get(query.sfid).then((result) => {
                this.setState({user: result, isFetchingUser: false});
            }).catch((error) => {
                console.error('user error', error);
                this.setState({isFetchingUser: false});
            });
        } else {
            this.setState({isFetchingUser: false});
        }
        gtmPageview(PATH_REQUEST_TESTDRIVE);
    }

    onSubmit = (values) => {
        this.setState({submitted: true, submittedData: values});
        // this.props.history.push(`${PATH_REQUEST_TESTDRIVE}${PATH_THANKS}`);
        window.scrollTo(0,0);
        gtmPageview(`${PATH_REQUEST_TESTDRIVE}${PATH_THANKS}`);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const {submitted, submittedData, submittedDealer, submittedVariant, user, isFetchingUser} = this.state;
        var prefillMobile = "";
        if (user && user.mobile && user.mobile.indexOf('04') === 0) {
            prefillMobile = user.mobile.replace(/\s/g, '');
        }

        const fields = [
            {
                module: ModelModule,
                form: "RaTD",
                title: "Select a car",
                colClass: "col-12",
                labelModel: "Select your model *",
                labelVariant: "Select variant *",
                onVariantChange: (vOpt) => { this.setState({submittedVariant: vOpt}); }
            },
            // {
            //     module: DescriptionModule,
            //     modelListType: "test-drive-form"
            // },
            {
                module: DealerByPostcodeModule,
                postcodeName: "postCode",
                formName: "bookTestDrive"
            },
            {
                module: DateTimeModule,
                minDate: new Date(),
                title: "Add date & time you're available",
                isIframed: this.isIframed
            },
            {
                node: <p className="aui-headline-5 mb-2"><b>Enter your details</b></p>
            },
            [
              {
                  field: FIELD_TEXT,
                  name: "firstName",
                  label: "First name *",
                  value: user.firstName || ""
              },
              {
                  field: FIELD_TEXT,
                  name: "lastName",
                  label: "Last name *",
                  value: user.lastName || ""
              }
            ],
            {
                field: FIELD_TEXT,
                name: "emailAddress",
                label: "Email address *",
                value: user.email || ""
            },
            {
                field: FIELD_TEXT,
                name: "mobilePhone",
                label: "Mobile phone *",
                formatValue: formatMobile,
                value: prefillMobile
            },
            {
                field: FIELD_CHECKBOX_GROUP,
                name: "preferredContactMethod",
                label: "Preferred method of contact *",
                options: PREF_CONTACT_OPTIONS,
                delimeter: ";",
                value: user.preferredContactMethod || "Email",
                checkboxClassName: "me-5 mb-3"
            },
            {
              node: (<hr className="my-5" />)
            },
            {
                field: FIELD_CHECKBOX,
                name: "optIn",
                label: LABEL_OPTIN
            },
            {
                field: FIELD_CHECKBOX,
                name: "tradeIn",
                label: "I'd like to discuss trade in options."
            }
        ];

        return (
            <Layout ui={this.isIframed ? null : query.ui ? query.ui : UI_AUDI} theme={query.theme}>
                <Helmet>
                    <title>Request a test drive | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page ratd">
                  <div className="row">
                    
                    {!this.isIframed && <div className="col-5 d-none d-medium-block">
                      <div className="audi-forms-side-hero" style={{backgroundImage: `url("${process.env.PUBLIC_PATH}img/ratd_a3-sportback.jpg")`}}>
                        <div className="overlay">
                          <h1 className="aui-color-text-light aui-headline-2 p-5">Request a Test Drive</h1>
                        </div>
                      </div>
                    </div>}
                    
                    <div className="col-12 col-medium">
                      <div className="px-0 px-small-3 px-large-5 pt-3 pt-medium-5">
                      
                        {this.isIframed && <h1 className="aui-headline-2 mb-5 d-none d-medium-block">Request a Test Drive</h1>}

                        {submitted && <>
                            <p className="aui-headline-3 mb-4 text-center">Thank you</p>
                            <p className="mb-3 text-center">We will send you an email with your request.</p>
                            <p className="mb-3 text-center">
                                {submittedData.dealerName ? <>A team member from <b>{submittedData.dealerName}</b></> : 'We'}
                                {' '}will be in touch regarding your booking.
                            </p>
                            <div className="ratd-confirmation p-3">
                              <p className="aui-font-extended mb-2"><b>Car Requested</b></p>
                              <div className="text-center">
                                <img src={submittedVariant.jellybeanImage} alt="" style={{maxWidth: "50%"}} />
                                <p>{submittedVariant.label}</p>
                              </div>
                              <hr className="my-3" />
                              <p className="aui-font-extended mb-2"><b>Dealer</b></p>
                              <p>{submittedData.dealerName} {submittedDealer.state ? `- ${submittedDealer.state}` : ""}</p>
                              <p>{submittedDealer.Phone}</p>
                              <hr className="my-3" />
                              <p className="aui-font-extended mb-2"><b>Date Requested</b></p>
                              <p>{submittedData.preferredTestDriveDate}</p>
                              <p>{submittedData.preferredTestDriveTime === "Morning" && "AM"}{submittedData.preferredTestDriveTime === "Afternoon" && "PM"}</p>
                              <hr className="my-3" />
                              <p className="aui-font-extended mb-2"><b>Your Details</b></p>
                              <p>{submittedData.firstName} {submittedData.lastName}</p>
                              <p>{submittedData.emailAddress}</p>
                              <p>{submittedData.mobilePhone}</p>
                              <p className="mb-2">{submittedData.postCode}</p>
                              {submittedData.tradeIn && <p><IconSelect small /> I'd like to discuss trade in options</p>}
                            </div>
                        </>}

                        {!submitted && <>
                            <h1 className="aui-headline-3 mb-4 d-medium-none">Request a test drive</h1>
                            {MAINTENANCE_SF && <MaintenanceMessage />}
                        </>}

                        {isFetchingUser && <Loader><p><b>One moment, we are retrieving your details...</b></p></Loader>}

                        {!submitted && !isFetchingUser && <>
                            <AudiForm formName="bookTestDrive"
                                fields={fields}
                                schema={{
                                    preferredTestDriveDate: {
                                        presence: {
                                            message: "Please select a date",
                                            allowEmpty: false
                                        }
                                    },
                                    modelId: {
                                        presence: {
                                            message: "Please select a model",
                                            allowEmpty: false
                                        }
                                    },
                                    variantId: {
                                        presence: {
                                            message: "Please select a variant",
                                            allowEmpty: false
                                        }
                                    },
                                }}
                                preSubmit={(payload) => {
                                    if (payload.preferredTestDriveDate) {
                                        payload.preferredTestDriveDate = formatDate(payload.preferredTestDriveDate);
                                    }
                                    if (payload.dealer) {
                                        this.setState({submittedDealer: payload.dealer});
                                        payload.dealer = "";
                                    }
                                    return payload;
                                }}
                                onSubmitSuccess={this.onSubmit}
                                submitLabel="Request a test drive"
                                style={{maxWidth: "840px"}}
                                theme={query.theme}
                            />
                            <p className="mb-3 aui-small">All fields marked with * are mandatory.</p>
                            <Disclaimer />
                        </>}
                        
                      </div>
                    </div>
                  </div>
                </main>
            </Layout>
        );
    }

}

export default RequestTestDrive;
